import { queryClient, apiRequest } from "../lib/queryClient";

const backgroundPatternKey = "backgroundPattern";

export function useBackgroundPattern(options = {}) {
  const {
    filters = {},
    sort = { field: "created_at", direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchBackgroundPattern = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);

    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value);
      }
    }
    const response = await apiRequest(
      `/admin/bg-pattern/?${queryParams.toString()}`,
      {
        method: "GET",
      }
    );
    return response;
  };

  const createBackgroundPattern = async (pageData) => {
    const response = await apiRequest("/admin/bg-pattern/", {
      method: "POST",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [backgroundPatternKey] });
    return response;
  };

  const updateBackgroundPattern = async (pageData) => {
    const { _id, ...rest } = pageData;
    const response = await apiRequest(`/admin/bg-pattern//${_id}`, {
      method: "PUT",
      body: JSON.stringify(rest),
    });
    queryClient.invalidateQueries({ queryKey: [backgroundPatternKey] });
    return response;
  };

  const deleteBackgroundPattern = async (pageId) => {
    await apiRequest(`/admin/bg-pattern//${pageId}`, {
      method: "DELETE",
    });
    queryClient.invalidateQueries({ queryKey: [backgroundPatternKey] });
    return pageId;
  };

  const toggleBackgroundPatternStatus = async (id) => {
    const response = await apiRequest(`/admin/bg-pattern/${id}`, {
      method: "PATCH",
    });
    queryClient.invalidateQueries({ queryKey: [backgroundPatternKey] });
    return response;
  };

  const toggleDefaultBackgroundPattern = async (id) => {
    const response = await apiRequest(`/admin/bg-pattern/default/${id}`, {
      method: "PATCH",
    });
    queryClient.invalidateQueries({ queryKey: [backgroundPatternKey] });
    return response;
  };

  const toggleIsExclusive = async (id, allowExclusive) => {
    const response = await apiRequest(
      `/admin/bg-pattern/exclusive/${id}/${allowExclusive ? "allow" : "deny"}`,
      {
        method: "PATCH",
      }
    );
    queryClient.invalidateQueries({ queryKey: [backgroundPatternKey] });
    return response;
  };

  return {
    fetchBackgroundPattern,
    createBackgroundPattern,
    updateBackgroundPattern,
    deleteBackgroundPattern,
    toggleBackgroundPatternStatus,
    toggleDefaultBackgroundPattern,
    toggleIsExclusive,
  };
}
